/**
 * Hotels Popups Selectors
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';
import { QNA_GALLERY_POPUP_KEY } from '../slices/popupsSlice';

const selectHotelsPopupsState = (state: RootState) => state.hotels.popups;

export const selectHotelsCurrentPopup = createSelector(
  [selectHotelsPopupsState],
  (popups) => popups.currentPopup,
);

export const selectHotelsPopupMap = createSelector(
  [selectHotelsPopupsState],
  (popups) => popups.popupMap,
);

export const selectHotelsCurrentPopupData = createSelector([selectHotelsPopupsState], (popups) => {
  if (!popups.currentPopup) return null;
  return popups.popupMap[popups.currentPopup] ?? null;
});

export const selectQnAGalleryPopupData = createSelector([selectHotelsPopupMap], (popupMap) => {
  const data = popupMap[QNA_GALLERY_POPUP_KEY];
  return data && 'categories' in data ? data.categories : null;
});
